import { createFileRoute, useNavigate } from '@tanstack/react-router';

import { parseEstimatesSearch } from '../../../features/estimates/model/filters.ts';
import { EstimatesList } from '../../../features/estimates/ui/estimates-list.tsx';
import { SalesHeader } from '../../../features/sales/ui/sales-tabs.tsx';
import { requirePermissionRoute, usePermissions } from '../../../lib/permissions.ts';

export const Route = createFileRoute('/_app/sales/estimates')({
  validateSearch: (search: Record<string, unknown>) => parseEstimatesSearch(search),
  beforeLoad: requirePermissionRoute('sales.use'),
  component: EstimatesRoute,
});

/** «Сметы» (`/sales/estimates?filter=review|mine|all`): очередь проверки у админа, свои сметы у менеджера. */
function EstimatesRoute() {
  const search = Route.useSearch();
  const navigate = useNavigate({ from: Route.fullPath });
  const { can } = usePermissions();
  const filter = search.filter ?? (can('proposals.review') ? 'review' : 'mine');
  return (
    <div className="relative flex min-h-full w-full flex-col gap-4 px-4 py-5 md:px-6">
      <SalesHeader />
      <EstimatesList
        filter={filter}
        onFilter={(next) => {
          void navigate({ search: { filter: next }, replace: true });
        }}
      />
    </div>
  );
}
